module.exports = __webpack_public_path__ + "img/logoOhneSchrift.362f1adf.png";